import gql from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable';
import { reactive, ref, watch } from 'vue';
import useDecryptSymbols from './useDecryptSymbols';
import useAlerts from './useAlerts';

const { decryptSymbols } = useDecryptSymbols();
const { addAlert } = useAlerts();

const quoteProducts = reactive([]);
const loadingQuoteProducts = ref(false);
const refetchQuoteProducts = ref(null);

const GET_QUOTE_PRODUCTS = gql`
  query QuoteProductsQuery {
    quoteProducts {
      PRODUCTID
      PARTNUM
      OLDPARTNUM
      DESCRIPTION
      COLOR
      UOM
      WEIGHT
      PIECESPERSQFT
      prices {
        PRICEID
        PRODUCTID
        PRICELISTID
        PRICEPC
        PRICESQFT
        priceListName
      }
    }
  }
`;

function useQuoteProductsQuery() {
  const { result, loading, error, refetch } = useQuery(GET_QUOTE_PRODUCTS, {}, { fetchPolicy: 'no-cache' });
  refetchQuoteProducts.value = refetch;
  loadingQuoteProducts.value = loading.value;

  watch(result, () => {
    const decrypted = decryptSymbols(result.value?.quoteProducts || []);
    quoteProducts.splice(0, quoteProducts.length, ...decrypted);
  });

  watch(loading, () => {
    loadingQuoteProducts.value = loading.value;
  });

  watch(error, () => {
    if (error.value) {
      console.error('Error fetching quote products:', error.value);
      addAlert('Error fetching quote products', 'high', 4);
    }
  });

  return { result, loading, error };
}

export default {
  useQuoteProductsQuery,
  quoteProducts,
  loadingQuoteProducts,
  refetchQuoteProducts,
};
